// AI-DATA-MAP-1A: the "Data map" of one AI Register row. Display only.

export interface DataMap {
  status: 'mapped' | 'not_mapped'
  purpose?: string
  data_sent?: string
  personal_data?: string
  sent_to?: string
  output_used_for?: string
  human_check?: string
  limits?: string
  affected_if_wrong?: string
  evidence?: string[]
}

const FIELDS: { label: string; field: keyof DataMap }[] = [
  { label: 'Purpose', field: 'purpose' },
  { label: 'Data sent to the model', field: 'data_sent' },
  { label: 'Personal data', field: 'personal_data' },
  { label: 'Sent to', field: 'sent_to' },
  { label: 'Output used for', field: 'output_used_for' },
  { label: 'Human check', field: 'human_check' },
  { label: 'Known limits', field: 'limits' },
  { label: 'Affected if wrong', field: 'affected_if_wrong' },
]

export function DataMapPanel({ fkey, map }: { fkey: string; map?: DataMap }) {
  if (!map || map.status !== 'mapped') {
    return <p data-testid={`register-datamap-${fkey}`} className="text-sm text-gray-500">Not mapped yet</p>
  }
  return (
    <div data-testid={`register-datamap-${fkey}`} className="text-sm">
      <dl className="grid grid-cols-1 gap-x-4 gap-y-1 sm:grid-cols-[12rem_1fr]">
        {FIELDS.map(({ label, field }) => (
          <div key={field} className="contents">
            <dt className="font-medium text-gray-700">{label}</dt>
            <dd>{String(map[field] ?? '')}</dd>
          </div>
        ))}
      </dl>
      {map.evidence && map.evidence.length > 0 && (
        <p className="mt-2 text-xs text-gray-400">Evidence: {map.evidence.join(', ')}</p>
      )}
    </div>
  )
}
